export function PlatIndexTemplate(params) {
    return `<table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
              <tr>
                  <th class="third">Plat</th>
                  <td class="two-third">{MapIndexNo}</td>
              </tr>
              <tr>
                  <th class="third">Page</th>
                  <td class="two-third">
                      <a target="_blank" href="{Image}" class="ui fluid tiny button">View PDF</a>
                  </td>
              </tr>
          </tbody>
      </table>`;
  }
  